export const hashRegexp: RegExp = /^#(\w+)=(\d+)$/;
